export default __webpack_public_path__ + "static/media/Group -65.a7af2c46.png";